<div [formGroup]="addSimToBoxForm" fxLayout="column">
  <div *ngIf="generalError" class="mat-error">
    {{generalError?.message}}
  </div>

  <mat-form-field>
    <mat-label>Sim</mat-label>
    <mat-select [(value)]="selectedSim" formControlName="sim" name="sim">
      <mat-option *ngIf="!loadingSims && sims.length === 0">
        No sims available.
      </mat-option>
      <mat-option *ngFor="let sim of sims" [value]="sim">
        {{sim?.identifier}}
      </mat-option>
    </mat-select>
    <span *ngIf="loadingSims" matPrefix><i class="fas fa-spinner fa-spin color-primary"></i>&nbsp;</span>
    <mat-hint *ngIf="!loadingSims && sims.length === 0" class="color-warn">
      No sims available.
    </mat-hint>
  </mat-form-field>


  <div fxLayout="row" fxLayoutAlign="end">
    <button (click)="box = _box; canceled.emit()" mat-button>Cancel</button>
    <button (click)="addSim()" [disabled]="addSimToBoxForm.invalid || saving " color="primary" mat-button>
      <i *ngIf="saving" class="fas fa-spinner fa-spin"></i>
      <ng-container *ngIf="!saving">Save</ng-container>
    </button>
  </div>

</div>